// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"7c5aa7a9","369":"b2653e0e"}[chunkId] + ".chunk.js";
};